<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="$store.state.keepAliveRoutes">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { isInFrame, isIos12, localStore } from './utils'

const currentVersion = '__H5_VERSION__' // build时被替换
console.log('当前版本: __H5_VERSION__')
const lastVersion = localStore.getItem('H5_VERSION')
if (currentVersion != lastVersion) {
  localStore.setItem('H5_VERSION', '__H5_VERSION__')
}

if (isInFrame() && isIos12()) {
  // 修复ios12的iframe的高度会自动增加适应内容，这里限制死宽高
  document.documentElement.classList.add('in-ios12-iframe')
}

export default defineComponent({})
</script>

<style lang="scss">
// 解决ios12的iframe的高度会自动增加适应内容，这里限制死宽高
html.in-ios12-iframe {
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.ui-nowrap {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pf-medium {
  font-weight: 700;
}

.pf-simbold {
  font-weight: 700;
}

.y-e-ios {
  .pf-medium {
    font-weight: 500;
  }

  .pf-simbold {
    font-weight: 600;
  }
}

.y-e-android {
  .amend-pt {
    padding-top: 1px !important;
  }
  .tran-pt {
    transform: translateY(1px);
  }
}

/* 开启gpu渲染，防样式穿透 */
.sticky-fix .van-sticky--fixed {
  &::before {
    content: '';
    display: block;
    position: absolute;
    background: var(--fix-bg);
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    // 必须要设置translateZ(0),开启gpu渲染
    transform: translateY(-2px) translateZ(0);
  }
}
.van-image-preview__overlay {
  &::before {
    content: '';
    display: block;
    position: absolute;
    background: rgba(0, 0, 0, 0.9);
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    // 必须要设置translateZ(0),开启gpu渲染
    transform: translateY(-2px) translateZ(0);
  }
}
.van-image-preview__image > * {
  transform: translateZ(0);
}

/* 部分机型使用fit-content宽度会有明显的变化过程 */
.van-toast--text {
  width: initial;
}

.theme-primary-font-color {
  color: #ff5900;
}
</style>
